import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(ICategoryPageLayoutRequest) {
    (function(PageType) {
        PageType["PAGE_TYPE_UNKNOWN"] = "PAGE_TYPE_UNKNOWN";
        PageType["NORMAL_CATEGORY_PAGE"] = "NORMAL_CATEGORY_PAGE";
        PageType["NEW_BRAND_PAGE"] = "NEW_BRAND_PAGE";
        PageType["NEW_PRODUCT_PAGE"] = "NEW_PRODUCT_PAGE";
        PageType["PREORDER_MARKETPLACE"] = "PREORDER_MARKETPLACE";
        /**
     * @deprecated
     */ PageType["PREORDER_PRODUCT"] = "PREORDER_PRODUCT";
        PageType["PLUS_SIZE_PAGE"] = "PLUS_SIZE_PAGE";
        /**
     * @deprecated
     */ PageType["FAIRE_SPECIALS_PAGE"] = "FAIRE_SPECIALS_PAGE";
        PageType["PREORDER_PAGE"] = "PREORDER_PAGE";
    })(ICategoryPageLayoutRequest.PageType || (ICategoryPageLayoutRequest.PageType = {}));
    ICategoryPageLayoutRequest.build = function(partial) {
        return _object_spread({
            filter_keys: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ICategoryPageLayoutRequest || (ICategoryPageLayoutRequest = {}));
export var ICategoryPageLayoutRequest;
